import React, { useState } from 'react';
import { Tabs, Typography } from 'antd';
import { CreditCardOutlined, TeamOutlined, HistoryOutlined } from '@ant-design/icons';
import BillingSubscription from './Subscription/Subscription';
import BillingClients from './Clients/Clients';
import BillingHistory from './History/History';

const { Title } = Typography;

const Billing = () => {
  const [activeTab, setActiveTab] = useState('subscription');

  const items = [
    {
      key: 'subscription',
      label: (
        <span>
          <CreditCardOutlined /> Enterprise Subscription
        </span>
      ),
      children: <BillingSubscription />
    },
    {
      key: 'clients',
      label: (
        <span>
          <TeamOutlined /> Client Billing
        </span>
      ),
      children: <BillingClients />
    },
    {
      key: 'history',
      label: (
        <span>
          <HistoryOutlined /> Payment History
        </span>
      ),
      children: <BillingHistory />
    }
  ];

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Billing & Plans</Title>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        size="large"
      />
    </div>
  );
};

export default Billing;
